// Created by carsonaberle at 11/23/21
export const updateError = 'Error changing file status!';
export const updateSuccess = 'Successfully changed status!';
export const title = (files) => (files.length < 2 ? 'Change file status' : `Change ${files.length} files status`);
